import { Trans } from '@lingui/react/macro'
import {
  ToggleGroup,
  ToggleGroupItem,
} from 'designSystem/components/ToggleGroup'
import type { ViewMode } from 'features/knowledgeDocumentViewer/types'
import React, { useCallback, useRef } from 'react'

export const VIEW_MODE_TOGGLE_KEY_CAPTURE_SELECTOR =
  '[data-view-mode-toggle-no-keys]'

export interface DocumentViewModeToggleProps {
  viewMode: ViewMode
  onViewModeChange: (value: string | number) => void
}

export function DocumentViewModeToggle({
  viewMode,
  onViewModeChange,
}: DocumentViewModeToggleProps): React.ReactElement {
  const viewModeRef = useRef(viewMode)
  viewModeRef.current = viewMode
  const onViewModeChangeRef = useRef(onViewModeChange)
  onViewModeChangeRef.current = onViewModeChange

  const handleValueChange = useCallback((nextViewMode: string): void => {
    if (nextViewMode === viewModeRef.current) return
    if (nextViewMode === 'card' || nextViewMode === 'table') {
      onViewModeChangeRef.current(nextViewMode)
    }
  }, [])

  return (
    <div
      data-view-mode-toggle-no-keys
      onKeyDownCapture={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}>
      <ToggleGroup
        type='single'
        variant='outline'
        size='lg'
        value={viewMode}
        onValueChange={handleValueChange}>
        <ToggleGroupItem value='card'>
          <Trans>Card</Trans>
        </ToggleGroupItem>
        <ToggleGroupItem value='table'>
          <Trans>Table</Trans>
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  )
}
